/*
 * HYDN · Galería por color
 * Al elegir un color en la ficha, muestra solo las fotos de ese color.
 * Una foto pertenece a un color si su texto alternativo contiene el nombre exacto del color
 * (p. ej. "Musculosa HYDN White / Taupe, mockup frontal"). Las fotos sin color siguen visibles.
 * Si ninguna foto del producto menciona el color elegido, no se oculta nada.
 */
(() => {
  if (window.__hydnVariantGallery) return;
  window.__hydnVariantGallery = true;

  const HIDDEN = 'hydn-color-hidden';
  const style = document.createElement('style');
  style.textContent = '.' + HIDDEN + '{display:none !important;}';
  document.head.appendChild(style);

  const norm = (s) => (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  const mediaIdOf = (el) => {
    const raw = el.dataset.mediaId || el.dataset.target || '';
    return raw.split('-').pop();
  };

  function colorState(info) {
    const selects = info.querySelector('variant-selects');
    if (!selects) return null;
    for (const fs of selects.querySelectorAll('fieldset')) {
      const legend = norm(fs.querySelector('legend') && fs.querySelector('legend').textContent);
      if (!/colou?r/.test(legend)) continue;
      const inputs = [...fs.querySelectorAll('input[type="radio"]')];
      const checked = inputs.find((i) => i.checked);
      return { values: inputs.map((i) => norm(i.value)), selected: checked ? norm(checked.value) : null };
    }
    for (const sel of selects.querySelectorAll('select')) {
      const label = norm((sel.name || '') + ' ' + (sel.id || ''));
      const lbl = info.querySelector('label[for="' + sel.id + '"]');
      if (!/colou?r/.test(label + ' ' + norm(lbl && lbl.textContent))) continue;
      return { values: [...sel.options].map((o) => norm(o.value)), selected: norm(sel.value) };
    }
    return null;
  }

  function apply(info) {
    const gallery = info.querySelector('media-gallery');
    if (!gallery) return;
    const items = [...gallery.querySelectorAll('ul.product__media-list > li[data-media-id]')];
    const state = colorState(info);
    const reset = () => {
      document.querySelectorAll('.' + HIDDEN).forEach((el) => {
        if (info.contains(el) || el.closest('product-modal')) el.classList.remove(HIDDEN);
      });
    };
    if (!state || !state.selected || state.values.length < 2) return reset();

    const hide = new Set();
    let selectedHasMedia = false;
    items.forEach((li) => {
      const img = li.querySelector('img');
      const alt = norm(img && img.getAttribute('alt'));
      const matches = state.values.filter((v) => v && alt.includes(v));
      if (matches.length !== 1) return; // foto general o ambigua: se mantiene
      if (matches[0] === state.selected) selectedHasMedia = true;
      else hide.add(mediaIdOf(li));
    });
    if (!selectedHasMedia) return reset();

    const targets = [
      ...gallery.querySelectorAll('[data-media-id], [data-target]'),
      ...document.querySelectorAll('product-modal [data-media-id]'),
    ];
    targets.forEach((el) => el.classList.toggle(HIDDEN, hide.has(mediaIdOf(el))));

    // Si la foto activa quedó oculta, activar la primera visible del color.
    const active = gallery.querySelector('ul.product__media-list > li.is-active');
    if (active && active.classList.contains(HIDDEN)) {
      const firstVisible = items.find((li) => !li.classList.contains(HIDDEN));
      if (firstVisible && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(firstVisible.dataset.mediaId, false);
      }
    }
    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
    if (viewer && typeof viewer.resetPages === 'function') viewer.resetPages();
    const thumbs = gallery.querySelector('slider-component[id^="GalleryThumbnails"]');
    if (thumbs && typeof thumbs.resetPages === 'function') thumbs.resetPages();
  }

  const applyAll = () => document.querySelectorAll('product-info').forEach(apply);
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      applyAll();
    });
  };

  document.addEventListener('change', (e) => {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) schedule();
  });

  const listen = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        schedule();
        setTimeout(applyAll, 150);
      });
      return true;
    }
    return false;
  };

  const start = () => {
    if (!listen()) setTimeout(listen, 500);
    applyAll();
    const obs = new MutationObserver((records) => {
      if (records.some((r) => r.target.closest && r.target.closest('media-gallery, variant-selects'))) schedule();
    });
    document.querySelectorAll('product-info').forEach((pi) => obs.observe(pi, { childList: true, subtree: true }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
